import request from '@/utils/request_python'

export function getProfiles(arpe_id) {
  return request({
    url: '/user/profiles',
    method: 'get',
    params: { arpe_id }
  })
}

export function getUsers(arpe_id) {
  return request({
    url: '/user/users',
    method: 'get',
    params: { arpe_id }
  })
}

export function createUser(user) {
  return request({
    url: '/user/create',
    method: 'post',
    data: user
  })
}

export function updateUser(user) {
  return request({
    url: '/user/update',
    method: 'post',
    data: user
  })
}

export function deleteUser(user_id) {
  return request({
    url: '/user/delete/' + user_id,
    method: 'get'
  })
}

export function getMenuUser(usua_id) {
  return request({
    url: '/user/get/menu',
    method: 'get',
    params: { usua_id }
  })
}

export function getMenuByUser(usua_id, arpe_id) {
  return request({
    url: '/user/menu/user',
    method: 'get',
    params: { usua_id, arpe_id }
  })
}

export function saveMenuByProfile(data, arpe_id) {
  return request({
    url: `/user/save/profile`,
    method: 'post',
    params: { arpe_id },
    data
  })
}
export function saveMenuByUser(data, usua_id, arpe_id) {
  return request({
    url: `/user/save/user`,
    method: 'post',
    params: { usua_id, arpe_id },
    data
  })
}

export function getMenuByProfile(arpe_id, arpe_id_admin) {
  return request({
    url: `/user/menu/profile`,
    method: 'get',
    params: { arpe_id, arpe_id_admin }
  })
}
